import { Injectable } from '@angular/core';
import { CustomOrderEntry } from '@cart/const';
import { ActiveCartService } from '@cart/data-access';
import { getCartIdByUserId } from '@cart/utils';
import { SnackTheme } from '@main/snackbar/const';
import { SnackbarFacade } from '@main/snackbar/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { RepeatOfflineOrderParams } from '@order/const';
import { OccOrderService, OrderActions } from '@order/data-access';
import { CartModification, UserIdService } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, take, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class OfflineOrderRepeatEffect {
  repeatOrder$: Observable<OrderActions.OfflineOrderRepeatActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderActions.OFFLINE_ORDER_REPEAT),
      map((action: OrderActions.OfflineOrderRepeat) => action.payload),
      switchMap(({ orderCode }) =>
        this.activeCartService.requireLoadedCart().pipe(
          withLatestFrom(this.userIdService.getUserId()),
          map(([cartState, userId]) => ({
            cartId: getCartIdByUserId(cartState.value, userId),
            offlineOrderCode: orderCode,
          })),
          take(1),
          filter(({ cartId, offlineOrderCode }: RepeatOfflineOrderParams) => !!cartId && !!offlineOrderCode),
        ),
      ),
      switchMap((payload) =>
        this.occOrderService.repeatOfflineOrder(payload).pipe(
          map((data) => {
            data.cartModifications
              .filter((item: CartModification) => item.quantity !== item.quantityAdded)
              .forEach((item) => {
                {
                  this.snackbarFacade.setSnack({
                    title: item.entry.product.name,
                    text:
                      item.quantityAdded === 0
                        ? `Товар отсутствует`
                        : `Осталость только ${item.quantityAdded} ${
                            (item.entry as CustomOrderEntry).saleUnit?.name || ''
                          }`,
                    delay: 5000,
                  });
                }
              });

            return new OrderActions.OfflineOrderRepeatSuccess();
          }),
          catchError((error: unknown) => {
            this.snackbarFacade.setSnack({
              theme: SnackTheme.Yellow,
              title: 'Ошибка',
              text: 'Не удалось повторить заказ',
            });

            return of(new OrderActions.OfflineOrderRepeatFail({ error }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private occOrderService: OccOrderService,
    private snackbarFacade: SnackbarFacade,
    private activeCartService: ActiveCartService,
    private userIdService: UserIdService,
  ) {}
}
